export const FormLabel = {
    baseStyle: {
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '20px',
        color: 'gray.600',
        marginBottom: '8px',
    },
};
